<div class="table-container">
<table mat-table [dataSource]="tableDataSource" matSort class="mat-elevation-z2 option-table">

  <ng-container matColumnDef="OptionTypeID">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"OptionType" | translate}}</th>
    <td mat-cell *matCellDef="let row" style="text-align: left !important; white-space: nowrap;">
      <mat-icon style="margin: 0 .5rem -.45rem .5rem;">{{ row.optIcon }}</mat-icon>
      {{ row.optProductID }}
    </td>
  </ng-container>

  <ng-container matColumnDef="Name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
    <td mat-cell *matCellDef="let row" class="description-cell"
        [matTooltip]="row.optDescription"
        matTooltipShowDelay="400">
      {{ row.optName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="Einheit">
    <th mat-header-cell *matHeaderCellDef>Einheit</th>
    <td mat-cell *matCellDef="let row">{{ row.optUnit }}</td>
  </ng-container>

  <ng-container matColumnDef="Value">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"dialog.amount" | translate}}</th>
    <td mat-cell *matCellDef="let row">{{ row.Value }}</td>
  </ng-container>

  <ng-container matColumnDef="StartDate">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"dialog.start" | translate}}</th>
    <td mat-cell *matCellDef="let row">{{ row.StartDate }}</td>
  </ng-container>

  <ng-container matColumnDef="EndDate">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"dialog.end" | translate}}</th>
    <td mat-cell *matCellDef="let row">{{ row.EndDate || ('Unlimited' | translate) }}</td>
  </ng-container>

  <ng-container matColumnDef="delete" *ngIf="!verify">
    <th mat-header-cell *matHeaderCellDef>{{"Delete" | translate}}</th>
    <td mat-cell *matCellDef="let row">
      <button (click)="removeFromCurrentList(row)" class="addSymbol">
        <span class="material-symbols-outlined">delete</span>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-row"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
</div>

<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0" />
